import React from "react";
import {Container, Row, Col} from "react-bootstrap";

import "./Page.css";
import variables from "../../Story/variables";

const Page = (props) => {

    const getBackground = () => {
        const colors = [
            ["rgba(125,111,120,0.5)", "rgba(212,188,204,0.5)", "rgba(222,209,186,0.5)"],
            ["rgba(252,229,189,0.5)", "rgba(252,229,189,0.5)", "rgba(252,229,189,0.5)"],
            ["rgba(255,210,134,0.4)", "rgba(118,91,50,0.4)", "rgba(57,57,57,0.5)"]
        ];
        const backgroundColor = props.background === "default" ?
            colors[variables.game.time[1]][variables.game.time[0]] :
            props.background;

        return {backgroundColor}
    };

    return (
        <div className="page" id="page">
            <Container fluid style={getBackground()}>
                <Row>
                    <Col lg={2} className="d-none d-xl-block"/>
                    <Col>
                        {props.passages[props.current]}
                    </Col>
                    <Col lg={2} className="d-none d-xl-block"/>
                </Row>
            </Container>
        </div>
    )
};

export default Page;